var anchorMenuElement = $('#section-anchor-menu nav a');

export function set_active_anchor_menu_onscroll(section) {
    if (anchorMenuElement.length) {
        let menuItem = $('#section-anchor-menu nav a.menu-'+section.attr('id'));
        $('.anchor-menu nav > a').removeClass('active');
        if (menuItem.length > 0) {
            $(menuItem).addClass('active');
        }

    }
}

export function set_condition_anchor_menu(condition) {
    if (anchorMenuElement.length) {
        let anchorMenuSection = $('#section-anchor-menu');
        let menuHome = $('#section-anchor-menu nav a.menu-section-home');

        if(condition == 'hide') {
            $(menuHome).addClass('active').siblings().removeClass('active');
            $(anchorMenuSection).hide();
        }

        if(condition == 'show') {
            $(anchorMenuSection).show();
        }

        if(condition == 'set_home_active') {
            $(menuHome).addClass('active').siblings().removeClass('active');
        }
    }
}


// WEBPACK FOOTER //
// ./scripts/global/anchor-menu.js